import React, { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { GeoclientApi } from '../../../api/GeoclientApi';
import GeoclientToursInQuoteEdit from './GeoclientToursInQuoteEdit';
import GeoclientToursInQuoteCreate from './GeoclientToursInQuoteCreate';

const GeoclientTours = (props) => {
  const [tours, setTours] = useState([]);
  const [isProgress, setIsProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  let localStorageQuoteTitle = localStorage.getItem('quoteTitle')
    ? localStorage.getItem('quoteTitle')
    : '';

  const [quoteTitle, setQuoteTitle] = useState(localStorageQuoteTitle);

  useEffect(() => {
    setTours(props.tours);
  }, [props.tours]);

  useEffect(() => {
    getQuoteTitle();
  }, [props.isQuoteEdit]);

  const onReset = () => {
    setErrorMessage('');
    setSuccessMessage('');
    setQuoteTitle('');
    props.onReset();
  };

  function handleQuoteActionSuccess(res) {
    setSuccessMessage(res.error);
    setIsProgress(false);
    clearMessagesAfterUpdate();
    clearDataAfterUpdate();
    setTimeout(() => {
      props.getQuotes();
    }, 3000);
  }

  function handleQuoteActionError(e) {
    setIsProgress(false);
    setErrorMessage(e.message);
    clearMessagesAfterUpdate();
  }

  function clearDataAfterUpdate() {
    props.changeEditStatus(false);
    localStorage.setItem('tourStack', JSON.stringify([]));
    localStorage.removeItem('quoteId');
    localStorage.removeItem('quoteTitle');
    setQuoteTitle('');
  }

  function clearMessagesAfterUpdate() {
    setTimeout(() => {
      setSuccessMessage('');
      setErrorMessage(null);
    }, 3000);
  }

  function getQuoteTitle() {
    localStorageQuoteTitle = localStorage.getItem('quoteTitle')
      ? localStorage.getItem('quoteTitle')
      : '';
    setQuoteTitle(localStorageQuoteTitle);
  }

  const handleCreateQuote = () => {
    let token = localStorage.getItem('token');
    let tours = JSON.parse(localStorage.getItem('tourStack'));
    if (!token) {
      setErrorMessage('возникла ошибка, сообщите администратору');
      return false;
    }
    const updatedQuote = { title: quoteTitle, tours };
    setIsProgress(true);

    GeoclientApi.createQuote(token, updatedQuote)
      .then((res) => {
        if (res.error === 'Не удалось загрузить данные о пользователе') {
          if (localStorage.getItem('refresh')) {
            updateToken().then((success) => {
              if (success) {
                handleCreateQuote();
              } else {
                throw new Error(res.error);
              }
            });
          } else {
            throw new Error(res.error);
          }
        } else {
          handleQuoteActionSuccess(res);
        }
      })
      .catch((e) => {
        handleQuoteActionError(e);
      });
  };

  function updateToken() {
    const refreshToken = localStorage.getItem('refresh');
    return GeoclientApi.updateToken(refreshToken).then((res) => {
      if (res.token && res.auth) {
        return true;
      } else {
        return false;
      }
    });
  }

  function handleQuoteEditSubmit() {
    const token = localStorage.getItem('token');
    const tours = JSON.parse(localStorage.getItem('tourStack'));
    if (!token) {
      setErrorMessage('Возникла ошибка, сообщите администратору');
      return false;
    }
    const quoteId = localStorage.getItem('quoteId');
    const updatedQuote = { title: quoteTitle, tours };
    setIsProgress(true);

    GeoclientApi.updateQuote(token, updatedQuote, quoteId)
      .then((res) => {
        handleQuoteActionSuccess(res);
      })
      .catch((e) => {
        handleQuoteActionError(e);
      });
  }

  const onDragEnd = ({ source, destination }) => {
    if (!destination || destination.index === source.index) return;

    let add,
      updatedTours = tours;

    add = updatedTours[source.index];
    updatedTours.splice(source.index, 1);

    updatedTours.splice(destination.index, 0, add);

    localStorage.setItem('tourStack', JSON.stringify(updatedTours));
    props.onUpdate();
  };

  return (
    <div id="tours" className="geoclient__tours">
      <DragDropContext onDragEnd={onDragEnd}>
        {tours.length ? (
          props.isQuoteEdit ? (
            <GeoclientToursInQuoteEdit
              tours={tours}
              isProgress={isProgress}
              handleQuoteEditSubmit={handleQuoteEditSubmit}
              setQuoteTitle={setQuoteTitle}
              quoteTitle={quoteTitle}
              {...props}
            />
          ) : (
            <GeoclientToursInQuoteCreate
              tours={tours}
              handleCreate={handleCreateQuote}
              onReset={onReset}
              isProgress={isProgress}
              setQuoteTitle={setQuoteTitle}
              {...props}
            />
          )
        ) : (
          <div>Для создания подборки выберите туры</div>
        )}
      </DragDropContext>
      {errorMessage ? (
        <p className="quote__message quote__message_error">{errorMessage}</p>
      ) : null}
      {successMessage ? (
        <p className="quote__message quote__message_success">
          {successMessage}
        </p>
      ) : null}
    </div>
  );
};

export default GeoclientTours;
